import ProductsList from '@js/pages/category/productsList';

ProductsList();
